module.exports = __webpack_public_path__ + "static/img/exit.b4e6e4d6.png";